function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M50.22 3.997H39.505v.001h-2.676V16l2.68-2.408V6.683h7.724l2.989-2.686z",
  fill: "#FA4504"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M54.676.002H40.816V12.43l2.678-2.406V2.688h8.194l2.99-2.686z",
  fill: "#FA4504"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.13 2.984v13.014h2.678V.002l-2.677 2.982z",
  fill: "#000"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.205 0l-5.3 5.902L3.605 0H.927L0 .002l3.605 4.012L7.103 7.91l1.802 2.006 1.802-2.006 3.498-3.895L17.808.002 16.884 0h-2.68zM0 .002l1.649 1.835L0 .002zM0 15.998h2.678V4.946L0 1.963v14.035zM35.904 0h-2.68l-5.3 5.902L22.625 0h-2.677l-.927.002 3.605 4.012 3.498 3.895.463.517 2.68 2.984V8.422l.46-.513 3.499-3.895L36.828.002 35.904 0zM26.586 15.998h2.68V13.59l-2.68-2.984v5.392zM72.5 2.686V.001H59.735v2.685H72.5zM55.888 15.998h2.678v-9.22l-2.678-2.983v12.203zM58.566 4.816V.002h-2.678v1.832l2.678 2.982z",
  fill: "#000"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M67.456 7.426V.002h-2.678v4.441l2.678 2.983zM64.778 6.406v9.592h2.678v-6.61l-2.678-2.982z",
  fill: "#000"
});

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgLogo;